import m from "../../es2015/lang/ja_JP";
window.am4lang_ja_JP = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ja_JP.js
// module id = null
// module chunks = 